import SmsOptInModal from 'components/SmsOptInModal/SmsOptInModal';

export default SmsOptInModal;
